<template>
  <div class="rounded-b-lg p-5 body-bg-color" :style="[customCss]">
    <div class="body-heading-color">
      <quill-editor
        v-if="!isPreview"
        :value="description"
        :options="getQuillEditorOptions('page-description')"
        @change="debounceUpdateDescription($event)"
      ></quill-editor>
      <div v-else v-html="description"></div>
    </div>
  </div>
</template>
<script>
import quillMixin from '../mixins/quill';
import { debounce } from 'lodash';
export default {
  name: 'FeaturedDescription',
  mixins: [quillMixin],
  data() {
    return {
      debounce,
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    text: {
      required: true,
    },
    updateDescription: {
      type: Function,
      required: true,
    },
    getThemeSettings: {
      type: Function,
      required: true,
    },
  },
  computed: {
    description() {
      return this.text;
    },
    customCss() {
      return {
        '--template-body-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--template-body-heading-color': this.themeSettings.body_section
          .body_heading_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
  methods: {
    debounceUpdateDescription: debounce(function (value) {
      return this.updateDescription(value);
    }, 1000),
  },
};
</script>
<style lang="scss" scoped>
.body-heading-color {
  color: var(--template-body-heading-color);
}
</style>
